module.exports = __webpack_public_path__ + "img/loading.f9c939fd.gif";